import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { FormattedMessage } from "react-intl";

import styles from "@components/carePlan/CarePlan.module.css";
import LegalDocuments from "@components/trackers/LegalDocuments";
import Medications from "@components/trackers/Medications";
import Providers from "@components/trackers/Providers";
import BodyCopy from "@components/typography/BodyCopy";
import Heading2 from "@components/typography/Heading2";
import { GetJourneyWithPlanQuery } from "@typing/Generated";
type Props = {
  journey: GetJourneyWithPlanQuery["journey"];
  mobileSpacing?: boolean;
};

const Trackers = ({ journey, mobileSpacing = false }: Props) => (
  <div className={mobileSpacing ? styles.mobileSpacing : ""}>
    <Heading2 bold color="gray">
      <FormattedMessage id="components.CarePlan.sections.trackers.title" />
    </Heading2>
    <div className="margin-10-bottom">
      <BodyCopy color="gray" size="small">
        <FormattedMessage id="components.CarePlan.sections.trackers.description" />
      </BodyCopy>
    </div>
    <IonGrid>
      <IonRow>
        <IonCol size="12" sizeLg="4" sizeXl="4">
          <Providers journey={journey} />
        </IonCol>
        <IonCol size="12" sizeLg="4" sizeXl="4">
          <Medications journey={journey} />
        </IonCol>
        <IonCol size="12" sizeLg="4" sizeXl="4">
          <LegalDocuments journey={journey} />
        </IonCol>
      </IonRow>
    </IonGrid>
  </div>
);

export default Trackers;
